<template>
  <div class="mt-10">
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Chat Widget
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Having more than one Whatsapp number? Our widget support multiple
            whatsapp numbers.
          </p>
          <WidgetPreview :config="config" />
        </div>
        <div class="md:col-span-2">
          <fieldset class="mt-6">
            <legend class="text-base leading-6 font-medium text-gray-900">
              Enable Widget
            </legend>

            <div class="mt-4 flex flex-wrap">
              <VSwitch v-model="config.widget.isEnabled" />
            </div>
          </fieldset>
          <fieldset class="mt-6">
            <legend class="text-base leading-6 font-medium text-gray-900">
              Name and Phone Numbers
            </legend>

            <div class="mt-4 ">
              <div
                class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Role
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Phone Number
                      </th>

                      <th scope="col" class="relative px-2 py-3"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Odd row -->
                    <tr
                      class="bg-white"
                      v-for="(number, index) in config.additionalAgents"
                      :key="index"
                    >
                      <td
                        class="px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                      >
                        {{ number.name }}
                      </td>
                      <td
                        class="px-2 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ number.description }}
                      </td>
                      <td
                        class="px-2 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ number.phoneNumber }}
                      </td>
                      <td
                        class="px-2 py-4 whitespace-nowrap text-right text-sm font-medium"
                      >
                        <a
                          class="text-indigo-600 hover:text-indigo-900 mx-2"
                          @click="editNumber(number, index)"
                          >Edit</a
                        >
                        <a
                          class="text-indigo-600 hover:text-indigo-900"
                          @click="deleteNumber(index)"
                          >Delete</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </fieldset>
          <div class="mt-2" v-if="showAddNumberForm === false">
            <a
              class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              @click="openNewNumberModal"
            >
              Add Another number
            </a>
          </div>
          <div class="mt-8">
            <div class="rounded-md">
              <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6 sm:col-span-6 lg:col-span-2 relative">
                  <label
                    for="city"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Header Color</label
                  >

                  <input
                    class="mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="config.colors.widgetHeaderColor"
                  />
                  <verte
                    picker="square"
                    v-model="config.colors.widgetHeaderColor"
                    class="colorPicker"
                    model="hex"
                  ></verte>
                </div>
                <div class="col-span-6 sm:col-span-6 lg:col-span-2 relative">
                  <label
                    for="city"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Header Text Color</label
                  >

                  <input
                    class="mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="config.colors.widgetHeaderTextColor"
                  />
                  <verte
                    picker="square"
                    v-model="config.colors.widgetHeaderTextColor"
                    class="colorPicker"
                    model="hex"
                  ></verte>
                </div>
              </div>
            </div>
            <div class="mt-6">
              <div class="">
                <div class="grid grid-cols-1 gap-6">
                  <div class="col-span-12 sm:col-span-6 lg:col-span-2 relative">
                    <label
                      for="city"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Header title</label
                    >

                    <input
                      class="mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      v-model="config.texts.widgetTitle"
                    />
                    <p
                      v-if="hasMoreTitleCharacters"
                      class="mt-2 text-sm text-red-600"
                      id="email-error"
                    >
                      Widget title should be less than 20 characters
                    </p>
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-6 mt-4">
                  <div class="col-span-12 sm:col-span-6 lg:col-span-2 relative">
                    <label
                      for="city"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Header description</label
                    >

                    <input
                      class="mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      v-model="config.texts.widgetDescription"
                    />
                    <p
                      v-if="hasMoreDescriptionCharacters"
                      class="mt-2 text-sm text-red-600"
                      id="email-error"
                    >
                      Widget Description should be less than 70 characters
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  class="Polaris-Button Polaris-Button--primary"
                  type="submit"
                  @click="update"
                >
                  <span class="Polaris-Button__Content">
                    <span class="Polaris-Button__Text">Save</span>
                  </span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddNewNumberModal
      v-if="showAddNumberForm"
      :agent="currentNumberToEdit"
      @close="closeModal"
      @create="addNewNumber"
      @update="updateNumber"
    />
  </div>
</template>

<script>
import VSwitch from "../../components/Common/VSwitch";
import Verte from "verte";
import AddNewNumberModal from "./AddNumberModal";
import WidgetPreview from "./WidgetPreview";

export default {
  name: "AdditionalAgents",
  components: {
    Verte,
    VSwitch,
    AddNewNumberModal,
    WidgetPreview
  },
  data() {
    return {
      newNumber: null,
      showAddNumberForm: false,
      form: {
        number: null,
        name: "",
        description: ""
      },
      currentNumberToEdit: null,
      currentEditIndex: null
    };
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    hasMoreTitleCharacters() {
      const label = this.config.texts.widgetTitle;
      return label.length > 20;
    },
    hasMoreDescriptionCharacters() {
      const label = this.config.texts.widgetDescription;
      return label.length > 70;
    }
  },
  mounted() {
    const config = this.config;
    if (
      config &&
      config.additionalAgents &&
      config.additionalAgents.length === 0 &&
      config.phoneNumber &&
      config.phoneNumber.length > 0
    ) {
      this.config.additionalAgents.push({
        name: "Customer care",
        description: "Chat with us",
        avatarUrl:
          "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-male.svg?v=1614858646",
        phoneNumber: config.phoneNumber,
        isEnabled: true
      });
    }
  },
  methods: {
    handlePhoneNumberUpdate(event, index) {
      console.log({ event, index });
    },
    update() {
      if (this.hasMoreTitleCharacters) {
        alert("widget title should be less than 20 characters");
        return;
      }
      if (this.hasMoreDescriptionCharacters) {
        alert("widget description should be less than 70 characters");
        return;
      }
      this.$emit("save");
    },
    addNewNumber({ name, description, phoneNumber, avatarUrl }) {
      this.config.additionalAgents.push({
        name,
        description,
        phoneNumber,
        avatarUrl,
        isEnabled: true
      });
      this.showAddNumberForm = false;
    },
    updateNumber({ name, description, phoneNumber, avatarUrl }) {
      this.config.additionalAgents[this.currentEditIndex] = {
        name,
        description,
        phoneNumber,
        avatarUrl,
        isEnabled: true
      };
      this.showAddNumberForm = false;
    },
    editNumber(number, index) {
      this.currentNumberToEdit = number;
      this.currentEditIndex = index;
      this.showAddNumberForm = true;
    },
    deleteNumber(index) {
      this.config.additionalAgents.splice(index, 1);
    },
    closeModal() {
      this.showAddNumberForm = false;
    },
    openNewNumberModal() {
      this.currentNumberToEdit = null;
      this.currentEditIndex = null;
      this.showAddNumberForm = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
